import type { TApiSupervisorSegment } from '~/modules/covenants/types.ts';

export type TCovenantsSegmentsManagerFormValues = {
  draftEmails: Record<string, string>;
  supervisorAdministrationDraftEmails: Record<string, string>;
};

export const buildSupervisorEmailFieldName = (segmentId: string) =>
  `draftEmails.${segmentId}` as const;

export const buildSegmentsManagerFormValues = (
  segments: TApiSupervisorSegment[],
  currentDraftEmails: Record<string, string> = {},
  currentSupervisorAdministrationDraftEmails: Record<string, string> = {}
): TCovenantsSegmentsManagerFormValues => ({
  draftEmails: segments.reduce<Record<string, string>>((accumulator, segment) => {
    accumulator[segment.segment.id] = currentDraftEmails[segment.segment.id] ?? '';
    return accumulator;
  }, {}),
  supervisorAdministrationDraftEmails: currentSupervisorAdministrationDraftEmails,
});

export const findSupervisorSegment = (
  segments: TApiSupervisorSegment[],
  segmentId: string
): TApiSupervisorSegment | undefined => segments.find((segment) => segment.segment.id === segmentId);

export const hasDuplicateSupervisorEmail = (
  segment: TApiSupervisorSegment | undefined,
  email: string
): boolean =>
  !!segment?.supervisors.some(
    (supervisor) => supervisor.email.toLowerCase() === email.toLowerCase()
  );

export const filterSupervisorSegments = (
  segments: TApiSupervisorSegment[],
  searchQuery: string
): TApiSupervisorSegment[] => {
  const normalizedQuery = searchQuery.trim().toLowerCase();

  if (!normalizedQuery) {
    return segments;
  }

  return segments.filter((segment) => {
    const segmentId = segment.segment.id.toLowerCase();
    const displayName = (segment.segment.displayName ?? '').toLowerCase();
    const supervisorEmails = segment.supervisors.map((supervisor) =>
      supervisor.email.toLowerCase()
    );

    return (
      segmentId.includes(normalizedQuery) ||
      displayName.includes(normalizedQuery) ||
      supervisorEmails.some((email) => email.includes(normalizedQuery))
    );
  });
};
